// Internal Imports
import de from '../assets/images/logos/magazine-logo-de.svg';
import en from '../assets/images/logos/magazine-logo-en.svg';
import es from '../assets/images/logos/magazine-logo-es.svg';
import it from '../assets/images/logos/magazine-logo-it.svg';
import pl from '../assets/images/logos/magazine-logo-pl.svg';
import pt from '../assets/images/logos/magazine-logo-pt.svg';

// Local Variables
const logos = {
  de,
  en,
  es,
  fr: en,
  it,
  pl,
  pt,
  sv: en,
};

// Module Exports
export { logos };
